import { useCallback, useEffect, useRef, useState } from 'react';

const COPIED_TOOLTIP_DURATION = 1500;

export const useCopiedTooltip = () => {
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    return () => window.clearTimeout(timerRef.current);
  }, []);

  const onCopied = useCallback(() => {
    window.clearTimeout(timerRef.current);
    setShowCopiedTooltip(true);
    timerRef.current = window.setTimeout(
      () => setShowCopiedTooltip(false),
      COPIED_TOOLTIP_DURATION,
    );
  }, []);

  const resetCopied = useCallback(() => {
    window.clearTimeout(timerRef.current);
    setShowCopiedTooltip(false);
  }, []);

  return { showCopiedTooltip, onCopied, resetCopied };
};
